import { FC } from 'react';

import {
  IconReact,
  IconIos,
  IconFlutter,
  IconAndroid,
  IconUnreal,
} from '@getstream/ui-library/build';

import styles from './CloudComponent.module.css';

export type Props = {
  component: {
    icon: string;
    to: string;
    label: string;
  };
};

export const CloudComponent: FC<Props> = ({ component }) => {
  const Icon = {
    IconReact,
    IconIos,
    IconFlutter,
    IconAndroid,
    IconUnreal,
  }[component.icon];
  return (
    <li className={styles.cloudComponent}>
      <a href={component.to}>
        <Icon />
        <h4>{component.label}</h4>
      </a>
    </li>
  );
};
